"use client";

import { c as _c } from "react/compiler-runtime";
import type { Offer } from "@local/offer/src/types";
import type { SweepstakesState } from "@local/offer/src/lib/const/sweepstakes";
import { useState } from "react";
import { getT } from "@local/i18n/src/t";
import { getLanguageForMarket } from "@local/i18n/src/languages";
import { home } from "@local/i18n/src/catalogs/home";
import { Button } from "../../ui/Button";
import { ContentBlock } from "../../ui/ContentBlock";
import { BestSellersBigBlock } from "./BestSellersBigBlock";
import { BestSellersMappedBlocks } from "./BestSellersMappedBlocks";
import { ArrowTitle } from "../../ui/ArrowTitle";
export interface BestSellersProps {
  content: Offer.BestSellers;
  market?: string;
  /**
   * Scheduled campaign state, resolved on the server. Passed in so SSR and
   * hydration render the same state; the client re-resolves it after mount.
   */
  sweepstakesState?: SweepstakesState;
}
export const BestSellers = t0 => {
  const $ = _c(19);
  const {
    content: t1,
    market,
    sweepstakesState
  } = t0;
  const {
    headline,
    mobileImage,
    products
  } = t1;
  const [isVisible, setIsVisible] = useState(false);
  let T0;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== headline || $[1] !== isVisible || $[2] !== market || $[3] !== mobileImage || $[4] !== products || $[5] !== sweepstakesState) {
    const t = getT(getLanguageForMarket(market), {
      home
    });
    const currentHeadline = headline ?? t("home.bestSellersHeadline");
    T0 = ContentBlock;
    t5 = "mt-6 flex max-w-6xl! flex-col justify-center py-10 lg:py-6";
    t2 = "relative mx-6 xl:mx-0";
    t3 = <ArrowTitle headline={currentHeadline} />;
    t4 = products?.length ? <div className={`relative grid grid-cols-1 gap-8 pt-6 md:grid-cols-2 ${isVisible ? "pb-8" : "pb-16 md:pb-8"}`}><div className="hidden md:block"><BestSellersBigBlock product={products?.[0]} mobileImage={mobileImage} market={market} sweepstakesState={sweepstakesState} /></div><div className="relative"><BestSellersMappedBlocks responsive={true} isVisible={isVisible} products={products} market={market} sweepstakesState={sweepstakesState} />{!isVisible && <div className="absolute -mt-6 w-full md:hidden"><Button type="button" onClick={() => setIsVisible(!isVisible)} className="bottom-1 mx-auto w-[91%] max-w-full min-w-0 text-lg font-medium uppercase md:w-full md:max-w-[340px]">{t("home.viewMore")}</Button></div>}</div></div> : null;
    $[0] = headline;
    $[1] = isVisible;
    $[2] = market;
    $[3] = mobileImage;
    $[4] = products;
    $[5] = sweepstakesState;
    $[6] = T0;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    T0 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t6 = <div className={t2}>{t3}{t4}</div>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== T0 || $[16] !== t5 || $[17] !== t6) {
    t7 = <T0 className={t5}>{t6}</T0>;
    $[15] = T0;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};
export { BestSellersShimmer } from "./Shimmer";